export const hasKey = (obj, key) => {
    return key in obj;
};
export const removeNullProperties = (originalObj, recursive = false) => {
    const newObj = {};
    for (const key in originalObj) {
        if (originalObj.hasOwnProperty(key) && originalObj[key] !== null) {
            const value = originalObj[key];
            newObj[key] =
                typeof value === 'object' && recursive
                    ? removeNullProperties(value, recursive)
                    : value;
        }
    }
    return newObj;
};
//# sourceMappingURL=objects.js.map